"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcTemplateSelector = exports.UcTemplate = exports.Templates = exports.TemplatePreview = exports.CreateTemplate = void 0;
const CreateTemplate_yaml_component_1 = __importDefault(require("./CreateTemplate.yaml?component"));
exports.CreateTemplate = CreateTemplate_yaml_component_1.default;
const TemplatePreview_yaml_component_1 = __importDefault(require("./TemplatePreview.yaml?component"));
exports.TemplatePreview = TemplatePreview_yaml_component_1.default;
const Templates_yaml_component_1 = __importDefault(require("./Templates.yaml?component"));
exports.Templates = Templates_yaml_component_1.default;
const UcTemplate_yaml_component_1 = __importDefault(require("./UcTemplate.yaml?component"));
exports.UcTemplate = UcTemplate_yaml_component_1.default;
const UcTemplateSelector_yaml_component_1 = __importDefault(require("./UcTemplateSelector.yaml?component"));
exports.UcTemplateSelector = UcTemplateSelector_yaml_component_1.default;
